import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-bootstrap/lib/Modal';
import Utils from '../../../utils/utils';

const RequestApprovalPopupLayout = ({ show, children }) => (
    <Modal show={show} dialogClassName="request-approval">
        <div className="block-header">
            <img className="alert-icon" src={`${Utils.getAssetsDomain()}/images/website/myplan/alert.svg`} />
        </div>
        {children}
    </Modal>
);

RequestApprovalPopupLayout.propTypes = {
    show: PropTypes.bool,
    children: PropTypes.arrayOf(PropTypes.element)
};

export default RequestApprovalPopupLayout;
